class PackSelectionComponent extends HTMLElement {
	constructor() {
		super()
		this.selectedSlot = null
		this.selectedPack = Number(this.querySelector('input[name="pack_variant"]:checked').value)
		this.productSlotInnerTemplate = this.querySelector(".product-slot-inner-template")
		this.productSlots = this.querySelectorAll(".product-slot")
		this.productSlotsExpansion = this.querySelectorAll(".product-slot__expansion")
		this.dropdown = this.querySelector(".expansion-slot__products")
		this.productSlotsVariants = this.querySelectorAll(".expansion-slot__products_item")
	}

	reset() {
		setTimeout(() => {
			this.querySelectorAll(".product-slot-inner-clone").forEach(clone => {
				clone.remove()
			})

			this.productSlotsExpansion.forEach(expansion => {
				expansion.classList.remove("hidden")
			})

			//Make sure to update the first pack with the selected variant.
			const productForm = document.querySelector("product-form-component")
			const selectedVariant = Number(productForm.formDataObject.id)
			const productDataEl = document.querySelector('[id^="ProductJson-"]') // use your product.id
			const product = JSON.parse(productDataEl.textContent)
			const defautlTemplate = this.querySelector(".product-slot-inner-template")

			const _variant = product.variants.filter(variant => variant.id === selectedVariant).reduce(t => t)
			defautlTemplate.querySelector("img").src = `${_variant.featured_image.src}&width=270`
			defautlTemplate.setAttribute("data-id", _variant.id)
		}, 100)
	}

	connectedCallback() {
		this.querySelectorAll('input[name="pack_variant"]').forEach(pack => {
			pack.addEventListener("change", () => {
				this.selectedPack = Number(pack.value)
				this.querySelectorAll(".product-slot-inner-clone").forEach(element => element.remove())
				this.productSlotsExpansion.forEach(element => element.classList.remove("hidden"))
			})
		})

		this.productSlotsExpansion.forEach(expansionSlot => {
			expansionSlot.addEventListener("click", event => {
				//Open products dropdown.
				console.log(expansionSlot.dataset)
				this.selectedSlot = Number(expansionSlot.dataset.index)
				this.dropdown.classList.toggle("hidden")
			})
		})
		this.productSlotsVariants.forEach(variant => {
			variant.addEventListener("click", () => {
				this.dropdown.classList.remove("hidden")

				const _variant = JSON.parse(variant.dataset.variant),
					selectedSlot = this.selectedSlot,
					template = this.productSlotInnerTemplate.cloneNode(true),
					slot = this.querySelector(`.product-slot.pack-index-${selectedSlot}`)
				template.classList.remove("product-slot-inner-template")
				template.classList.add("product-slot-inner-clone")

				slot.querySelector(".product-slot__expansion").classList.add("hidden")

				template.setAttribute("data-id", _variant.id)
				template.querySelector("img").src = `${_variant.featured_image.src}&width=270`
				template.querySelector("img").alt = variant.name

				//If there is a template before remove it.
				if (slot.querySelector(".product-slot-inner-clone")) {
					slot.querySelector(".product-slot-inner-clone").remove()
				}

				slot.append(template)

				template.addEventListener("click", () => {
					this.selectedSlot = selectedSlot
					this.dropdown.classList.toggle("hidden")
				})

				this.dropdown.classList.add("hidden")

				const productForm = document.querySelector("product-form-component form"),
					_form_change_event = new Event("change", {bubbles: true})
				productForm.dispatchEvent(_form_change_event)
			})
		})
	}
}

customElements.define("pack-selection-component", PackSelectionComponent)
